import { useTranslation } from 'react-i18next'

import { useTheme } from '@mui/material'
import Box from '@mui/material/Box'
import CircularProgress from '@mui/material/CircularProgress'
import Typography from '@mui/material/Typography'

const LoadingLabel = () => {
  const theme = useTheme()
  const { t } = useTranslation()
  return (
    <Box
      className='loading-label'
      style={{
        backgroundColor: theme.palette.background.paper,
        padding: '0.7rem 1rem',
        borderTopLeftRadius: '0.25rem',
        borderTopRightRadius: '0.25rem',
        position: 'absolute',
        bottom: '0',
        width: '20%',
        minWidth: '11rem',
        left: '50%',
        transform: 'translateX(-50%)',
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        boxShadow:
          '0px 3px 5px -1px rgba(0,0,0,0.2),0px 5px 8px 0px rgba(0,0,0,0.14),0px 1px 14px 0px rgba(0,0,0,0.12)',
      }}
    >
      <CircularProgress size={20} color='secondary' style={{ margin: '0 0.7rem 0 0' }} />
      <Typography color='secondary'>{`${t('loading')}...`}</Typography>
    </Box>
  )
}

export default LoadingLabel
